import { ChevronDown } from "lucide-react";
import { useState } from "react";
import PropertyCard from "./PropertyCard";

const OwnerCard = ({ owner, index, isOpen, onToggle }) => {
  const total = owner.sold.length + owner.bought.length;

  const [expandedStates, setExpandedStates] = useState({
    sold: owner.sold.map(() => false),
    bought: owner.bought.map(() => false),
  });

  const expandAll = () => {
    setExpandedStates({
      sold: owner.sold.map(() => true),
      bought: owner.bought.map(() => true),
    });
  };

  const collapseAll = () => {
    setExpandedStates({
      sold: owner.sold.map(() => false),
      bought: owner.bought.map(() => false),
    });
  };

  const isAllExpanded = expandedStates.sold.every(Boolean) && expandedStates.bought.every(Boolean);
  const isAllCollapsed = expandedStates.sold.every((v) => !v) && expandedStates.bought.every((v) => !v);

  const toggleSingle = (type, i) => {
    setExpandedStates((prev) => ({
      ...prev,
      [type]: prev[type].map((v, idx) => (idx === i ? !v : v)),
    }));
  };

  return (
    <div key={index} className="!w-full !border !border-gray-300 !rounded-lg !shadow-sm !bg-white !transition-all !duration-300 !overflow-hidden">
      {/* Header */}
      <div onClick={onToggle} className="!flex !justify-between !items-center !px-4 !py-3 !bg-gray-100 !cursor-pointer hover:!bg-gray-200 !transition">
        <div className="w-full flex item-center justify-between">
          <h2 className="!text-lg !font-semibold !text-[#008080]">{owner.name}</h2>
          <p className="!text-lg !text-[#008080] !mr-4">
            Total Records: <span className="!font-semibold">{total}</span>
          </p>
        </div>
        <ChevronDown className={`transition-all duration-500 ease-in-out !text-[#008080] ${isOpen ? "!rotate-180" : "rotate-0"}`} />
      </div>

      {/* Collapsible Body */}
      <div className={`transition-all duration-500 ease-in-out overflow-hidden ${isOpen ? "max-h-[700px] opacity-100" : "max-h-0 opacity-0"}`}>
        <div className="!flex !justify-end !px-5 !pt-3 !gap-3">
          <button onClick={expandAll} disabled={isAllExpanded} className={`!px-3 !py-1 !rounded !text-xs !font-semibold cursor-pointer ${isAllExpanded ? "!bg-gray-200 !text-gray-500 !cursor-not-allowed" : "!bg-green-500 hover:!bg-green-600 !text-white"}`}>
            Expand All
          </button>
          <button onClick={collapseAll} disabled={isAllCollapsed} className={`!px-3 !py-1 !rounded !text-xs !font-semibold cursor-pointer ${isAllCollapsed ? "!bg-gray-200 !text-gray-500 !cursor-not-allowed" : "!bg-red-500 hover:!bg-red-600 !text-white"}`}>
            Collapse All
          </button>
        </div>

        <div className="!grid md:!grid-cols-2 !gap-6 !p-5 !overflow-y-auto !max-h-[600px] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
          {/* Sold */}
          <div>
            <h3 className="!text-sm !font-semibold !text-red-600 !mb-2">Sold Properties ({owner.sold.length})</h3>
            {owner.sold.length > 0 ? owner.sold.map((p, i) => <PropertyCard key={i} property={p} type="sold" expanded={expandedStates.sold[i]} onToggle={() => toggleSingle("sold", i)} />) : <p className="!text-sm !text-gray-500 !italic">No sold records.</p>}
          </div>

          {/* Bought */}
          <div>
            <h3 className="!text-sm !font-semibold !text-green-600 !mb-2">Bought Properties ({owner.bought.length})</h3>
            {owner.bought.length > 0 ? owner.bought.map((p, i) => <PropertyCard key={i} property={p} type="bought" expanded={expandedStates.bought[i]} onToggle={() => toggleSingle("bought", i)} />) : <p className="!text-sm !text-gray-500 !italic">No bought records.</p>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OwnerCard;
